import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function Card({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement> & { children: ReactNode }) {
  return (
    <div
      {...rest}
      className={cn(
        'rounded-2xl border border-stone-200 bg-white p-5 shadow-sm',
        'dark:border-stone-800 dark:bg-stone-900',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function CardTitle({ children, className }: { children: ReactNode; className?: string }) {
  return <h2 className={cn('text-lg font-semibold mb-2', className)}>{children}</h2>;
}

export function CardSub({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <p className={cn('text-sm text-stone-600 dark:text-stone-400', className)}>{children}</p>
  );
}
